"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const constants_1 = require("./constants");
const types_1 = require("./types");
exports.generateToken = ({ type = types_1.Chars.AlphaNumeric, length = 32, pattern: injectedPattern } = {}) => {
    const pattern = injectedPattern || constants_1.TokenPattern.get(type);
    const totalChars = pattern.length;
    return Array.from(Array(length).keys()).reduce((token) => {
        token += pattern.charAt(Math.floor(Math.random() * totalChars));
        return token;
    }, '');
};
